import { render, staticRenderFns } from "./WorkOrderStatusDescriptionDialog.vue?vue&type=template&id=6a1c234f"
import script from "./WorkOrderStatusDescriptionDialog.vue?vue&type=script&lang=ts"
export * from "./WorkOrderStatusDescriptionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports